import { Skeleton } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { projectRoute as projectRouteDefinition } from '@townsquare/routes/project-view';

import { jiraIntegrationLinkResource } from './resources/JiraIntegrationLink';
import {
	projectDecisionsTabResource,
	projectLearningsTabResource,
	projectRisksTabResource,
} from './resources/ProjectLearningsTab';
import { projectSidebarAggResource } from './resources/ProjectSidebarAgg';
import { projectUpdatesResource, projectViewResource } from './resources/ProjectView';
import { projectViewAsideResource } from './resources/ProjectViewAside';
import { projectViewHeaderResource } from './resources/ProjectViewHeader';

projectRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "project-view" */ './components/ProjectView'),
	loading: () => null,
});

projectRouteDefinition.aside = Loadable({
	loader: () => import(/* webpackChunkName: "project-view-aside" */ './components/ProjectViewAside'),
	loading: () => null,
});

projectRouteDefinition.header = Loadable({
	loader: () => import(/* webpackChunkName: "project-view-header" */ './components/ProjectHeaderRefreshed'),
	loading: Skeleton,
});

projectRouteDefinition.resources = [
	projectLearningsTabResource,
	projectRisksTabResource,
	projectDecisionsTabResource,
	projectViewResource,
	projectViewAsideResource,
	projectViewHeaderResource,
	projectUpdatesResource,
	jiraIntegrationLinkResource,
	onboardingResource,
	projectSidebarAggResource,
];

export const projectRoute = projectRouteDefinition;
